// CONSTANTS are all caps.
const NS = 'FarmItem';
const CLS = 'farmItem';
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/farmItem.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class FarmItem {

	constructor($el) {
		// $el is the widget node return by the loadFarmItem function
		this.$el = $($el);
	}
}
